import { put, call, select, takeLatest } from 'redux-saga/effects';
import { pucksActions as actions, pucksActions } from '.';
import { PayloadAction } from '@reduxjs/toolkit';
// import { transformInsertsDTO } from './utils';
import {
  selectCustomerNumber,
  selectLanguageId,
} from 'app/features/erpSystem/slice/selectors';
import { erpalPayloadDTO } from '../../price/slice/utils';
import { selectErpSystem } from 'app/features/erpSystem/slice/selectors';
import { transformPucksDTO } from './utils';
import { selectStoreId } from 'app/features/salesOrganisation/slice/selectors';

function* setPucks(action: PayloadAction<any>) {
  const pucks = action.payload;
  const { setPucksSuccess, setPucksFailure } = pucksActions;

  try {
    if (pucks.length > 0) {
      const customerNumber = yield select(selectCustomerNumber);
      const languageId = yield select(selectLanguageId);
      const erpSystem = yield select(selectErpSystem);
      const storeId = yield select(selectStoreId);

      const pucksTransformed = yield erpalPayloadDTO(action.payload);
      const shopId = storeId % 10; // Get last digit of store id Ex: 100001  => 1

      const pucksPriceResponse = yield call(
        fetch,
        `/valve-configurator/api/price?customerNumber=${customerNumber}&shopId=${shopId}&currency=EUR&languageId=${languageId}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(pucksTransformed),
        },
      );
      const pucksPrice = yield pucksPriceResponse.json();

      const pucksStockResponse = yield call(
        fetch,
        `/valve-configurator/api/stockStatus?erpSystem=${erpSystem}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(pucksTransformed),
        },
      );
      const pucksStockStatus = yield pucksStockResponse.json();

      return yield put(
        setPucksSuccess(
          transformPucksDTO(pucks, pucksPrice.items, pucksStockStatus.items),
        ),
      );
    }
    return yield put(setPucksSuccess([]));
  } catch (e) {
    yield put(setPucksFailure(e));
  }
}

export function* pucksSaga() {
  yield takeLatest(actions.setPucksData.type, setPucks);
}
